
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles-v2/topic/[...slug]",
      function () {
        return require("private-next-pages/articles-v2/topic/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles-v2/topic/[...slug]"])
      });
    }
  